import { render } from "./IpRangesTabPublic.vue?vue&type=template&id=b38d33c4&scoped=true"
import script from "./IpRangesTabPublic.vue?vue&type=script&lang=js"
export * from "./IpRangesTabPublic.vue?vue&type=script&lang=js"

import "./IpRangesTabPublic.vue?vue&type=style&index=0&id=b38d33c4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38d33c4"]])

export default __exports__